import { normalizeWordDirection } from './insertBasedOnStrategy';

export function finalizeWordPlacement(engine, game, word, row, col, direction) {
  const originalWord = normalizeWordDirection(word, direction);

  game.settings.placedWords.push({
    word: originalWord,
    row,
    col,
    direction,
    length: word.length,
  });

  engine.state.removeUnplaced(word);
  engine.state.clearFailures(word);
}
